/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";
import { useGetConsumable } from "../../services/consumables";

export default function ConsumableDetails() {
  const params = useParams();

  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    // error: detailsError,
    reset: detailsReset,
  } = useGetConsumable();
  const {
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    if (params.consumableId) {
      getDetails(params.consumableId);
    }
  }, []);
  useEffect(() => {
    if (detailsRes) {
      const _res = detailsRes.data;

      reset({ ..._res });
      detailsReset();
    }
  }, [detailsRes]);

  const generalFieldProps = { errors, control };

  return (
    <>
      {gettingDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Consumables", link: Paths.consumable },
            { text: "Consumable Details", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                }}
              >
                <Heading>Consumable Details</Heading>
                <Button
                  as={Link}
                  to={`${Paths.editConsumable}/${params.consumableId || watch("consumableId")}`}
                >
                  Edit Consumable
                </Button>
              </div>

              <form className="add-location-form">
                <FormInput
                  {...generalFieldProps}
                  label="Cash Center"
                  name="cashCenter"
                  inputProps={{ readOnly: true }}
                />

                <FormInput
                  {...generalFieldProps}
                  label="Description"
                  name="description"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Seal No"
                  name="sealNo"
                  inputProps={{ readOnly: true }}
                />

                <FormInput
                  {...generalFieldProps}
                  label="Status"
                  name="status"
                  inputProps={{ readOnly: true }}
                />
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
